import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isScrolled, setIsScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isModalActive, setIsModalActive] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 80);
    };

    const checkModal = () => {
      setIsModalActive(document.body.style.overflow === 'hidden');
    };

    const observer = new MutationObserver(checkModal);
    observer.observe(document.body, { attributes: true, attributeFilter: ['style'] });

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      observer.disconnect();
    };
  }, []);

  const links = [
    { name: 'INICIO', path: '/' },
    { name: 'CATÁLOGO', path: '/productos' },
    { name: 'NOSOTROS', path: '/nosotros' }
  ];

  const isLightHero = isHomePage && !isScrolled;

  return (
    <nav className={`fixed top-0 left-0 right-0 px-4 md:px-12 transition-all duration-700 ${
      isScrolled ? 'py-4' : 'py-10'
    } ${
      isModalActive ? 'z-0 opacity-0 pointer-events-none' : 'z-[100] opacity-100'
    }`}>
      <div className={`max-w-7xl mx-auto px-8 py-4 rounded-full flex justify-between items-center transition-all duration-500 ${
        isScrolled 
          ? 'bg-white/90 backdrop-blur-xl border border-gray-100 shadow-2xl' 
          : 'bg-transparent border border-transparent'
      }`}>
        
        <Link to="/" className={`z-[110] transition-all duration-500 ${!isScrolled && isHomePage ? 'brightness-0 invert' : 'brightness-100'}`}>
          <img src="/logo_diana.png" alt="Logo" className="h-7 md:h-9 w-auto object-contain" />
        </Link>

        <div className="hidden md:flex gap-12 items-center">
          {links.map(link => {
            const isActive = location.pathname === link.path;
            return (
              <Link 
                key={link.path}
                to={link.path} 
                className={`text-[10px] font-black tracking-[0.3em] uppercase italic transition-all duration-300 relative group ${
                  isActive 
                    ? (isLightHero ? 'text-white' : 'text-[#a6192e]')
                    : (isLightHero ? 'text-white/60 hover:text-white' : 'text-slate-400 hover:text-slate-900')
                }`}
              >
                {link.name}
                <span className={`absolute -bottom-2 left-0 h-[2px] transition-all duration-300 ${
                  isActive ? 'w-full' : 'w-0 group-hover:w-full'
                } ${isLightHero ? 'bg-white' : 'bg-[#a6192e]'}`} />
              </Link>
            );
          })}
        </div>

        <button onClick={() => setIsOpen(!isOpen)} className="md:hidden z-[110] focus:outline-none">
          <div className="w-6 h-5 relative flex flex-col justify-between">
            <motion.span className={`w-full h-[2px] rounded-full transition-colors ${isLightHero && !isOpen ? 'bg-white' : 'bg-slate-900'}`} animate={isOpen ? { rotate: 45, y: 9 } : { rotate: 0, y: 0 }} />
            <motion.span className={`w-full h-[2px] rounded-full transition-colors ${isLightHero && !isOpen ? 'bg-white' : 'bg-slate-900'}`} animate={isOpen ? { opacity: 0 } : { opacity: 1 }} />
            <motion.span className={`w-full h-[2px] rounded-full transition-colors ${isLightHero && !isOpen ? 'bg-white' : 'bg-slate-900'}`} animate={isOpen ? { rotate: -45, y: -9 } : { rotate: 0, y: 0 }} />
          </div>
        </button>

        <AnimatePresence>
          {isOpen && (
            <motion.div initial={{ opacity: 0, y: -20, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: -20, scale: 0.95 }} className="absolute top-[110%] left-0 right-0 bg-white p-10 rounded-[2.5rem] shadow-[0_20px_50px_rgba(0,0,0,0.15)] flex flex-col gap-6 md:hidden z-[100] border border-gray-50">
              {links.map((link) => (
                <Link key={link.path} to={link.path} onClick={() => setIsOpen(false)} className={`text-sm font-black tracking-[0.3em] uppercase italic transition-colors ${location.pathname === link.path ? 'text-[#a6192e]' : 'text-slate-400'}`}>
                  {link.name}
                </Link>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </nav>
  );
};

export default Navbar;